"use client";

import { motion } from "framer-motion";

// IMAGES (replace with your own assets if needed)
import hero from "../../accests/kith/kith (2).jpg";
import rafting from "../../accests/kith/kith (1).jpg";
import flat from "../../accests/kith/kith (3).jpg";
import waterfall from "../../accests/kith/kithul.jpeg";
import birds from "../../accests/kith/kithul.jpeg";

export default function KitulgalaWaterRafting() {

    const highlights = [
        {
            title: "Whitewater Rafting",
            desc: "Conquer 4 major rapids and 3 minor rapids along a thrilling 5 km stretch of the Kelani River.",
            img: rafting
        },
        {
            title: "Flat Water Rafting",
            desc: "Kids and beginners can enjoy safe and fun rafting in the calm branches of the river.",
            img: flat
        },
        {
            title: "River Bathing",
            desc: "Take a refreshing swim in shallow and peaceful sections of the river.",
            img: flat
        },
        {
            title: "Waterfall Jumps & Abseiling",
            desc: "Test your courage with exciting waterfall jumps and abseiling adventures.",
            img: waterfall
        },
        {
            title: "Bird Watching",
            desc: "Spot colorful local bird species while drifting through lush jungle scenery.",
            img: birds
        }
    ];

    const itinerary = [
        "Pickup from your hotel",
        "Arrival at Kitulgala & meet adventure guide",
        "Safety briefing and gear setup",
        "Whitewater rafting on Kelani River",
        "Flat water rafting & river bathing",
        "Waterfall jumps & abseiling (optional)",
        "Birdwatching & nature exploration",
        "Return to your hotel"
    ];

    return (
        <div className="pt-28 bg-gray-50">

            {/* HERO */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
                className="relative h-[60vh]"
            >
                <img
                    src={hero}
                    alt="Kitulgala Water Rafting"
                    className="w-full h-full object-cover brightness-75"
                />
                <div className="absolute inset-0 flex flex-col justify-center items-center text-center text-white px-6">
                    <motion.h1
                        initial={{ y: -40, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 1, delay: 0.3 }}
                        className="text-5xl md:text-6xl font-bold drop-shadow-lg"
                    >
                        Kitulgala Water Rafting
                    </motion.h1>
                    <motion.p
                        initial={{ y: 40, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 1, delay: 0.6 }}
                        className="mt-4 max-w-3xl text-lg drop-shadow-md"
                    >
                        A thrilling whitewater adventure on Sri Lanka’s legendary Kelani River.
                    </motion.p>
                </div>
            </motion.div>

            {/* FEATURE HIGHLIGHTS */}
            <section className="max-w-7xl mx-auto px-6 py-20">
                <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 text-gray-800">
                    Places You Will Visit & Experiences
                </h2>

                <div className="grid md:grid-cols-2 gap-14 items-center">

                    {/* LEFT – IMAGE */}
                    <motion.div
                        initial={{ opacity: 0, x: -60 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        className="rounded-3xl overflow-hidden shadow-2xl"
                    >
                        <img
                            src={rafting}
                            alt="Kelani River Rafting"
                            className="w-full h-[420px] object-cover"
                        />
                    </motion.div>

                    {/* RIGHT – CONTENT */}
                    <motion.div
                        initial={{ opacity: 0, x: 60 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <h3 className="text-2xl md:text-3xl font-bold text-yellow-500 mb-4">
                            Water Rafting on the Kelani River
                        </h3>

                        <p className="text-gray-700 text-lg leading-relaxed mb-6">
                            Raft down the majestic Kelani River, navigating thrilling rapids in a wild jungle
                            setting. This 5 km journey combines challenging whitewater sections with calm,
                            scenic stretches — delivering both adrenaline and breathtaking natural beauty.
                        </p>

                        <ul className="space-y-3 text-gray-700 list-disc list-inside">
                            <li>4 major rapids & 3 minor rapids</li>
                            <li>5 km adventure through dense jungle</li>
                            <li>Perfect balance of excitement & relaxation</li>
                        </ul>
                    </motion.div>
                </div>

                {/* SECOND FEATURE */}
                <div className="grid md:grid-cols-2 gap-14 items-center mt-24">

                    {/* LEFT – CONTENT */}
                    <motion.div
                        initial={{ opacity: 0, x: -60 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <h3 className="text-2xl md:text-3xl font-bold text-green-600 mb-4">
                            Experience the Ultimate Adrenaline Rush
                        </h3>

                        <p className="text-gray-700 text-lg leading-relaxed mb-6">
                            This adventure-packed tour is designed for thrill-seekers who crave excitement.
                            From whitewater rafting and waterfall jumps to river bathing and jungle exploration,
                            every moment is filled with action and unforgettable memories.
                        </p>

                        <ul className="space-y-3 text-gray-700 list-disc list-inside">
                            <li>Waterfall jumps & optional abseiling</li>
                            <li>Flat water rafting for kids & beginners</li>
                            <li>River bathing & bird watching</li>
                        </ul>
                    </motion.div>

                    {/* RIGHT – IMAGE */}
                    <motion.div
                        initial={{ opacity: 0, x: 60 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        className="rounded-3xl overflow-hidden shadow-2xl"
                    >
                        <img
                            src={waterfall}
                            alt="Adrenaline Adventure Kitulgala"
                            className="w-full h-[420px] object-cover"
                        />
                    </motion.div>

                </div>

                {/* WHY CHOOSE + CTA */}
                <section className="relative py-24 overflow-hidden">

                    {/* BACKGROUND */}
                    <div className="absolute inset-0">
                        <img
                            src={hero}
                            alt="Why choose Kitulgala Water Rafting"
                            className="w-full h-full object-cover scale-110 blur-md"
                        />
                        <div className="absolute inset-0 bg-black/60"></div>
                    </div>

                    {/* CONTENT */}
                    <div className="relative max-w-6xl mx-auto px-6 text-white text-center">

                        <h2 className="text-3xl md:text-4xl font-bold mb-10">
                            Why Choose This Tour?
                        </h2>

                        <ul
                            className="max-w-3xl mx-auto space-y-4 text-lg list-disc list-inside
            backdrop-blur-md bg-white/10 p-8 rounded-3xl shadow-xl"
                        >
                            <li>Experience thrilling white-water rafting on the famous Kelani River.</li>
                            <li>Enjoy swimming at the iconic filming location of <strong>The Bridge on the River Kwai</strong>.</li>
                            <li>Navigate exciting rapids surrounded by lush rainforest and jungle scenery.</li>
                            <li>Explore hidden waterfalls, birdwatching spots, and river-side adventures.</li>
                            <li>Professional guides, safety equipment, and unforgettable adventure memories.</li>
                        </ul>

                        {/* CTA */}
                        <motion.div
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8 }}
                            className="mt-14"
                        >
                            <motion.a
                                whileHover={{ scale: 1.08 }}
                                whileTap={{ scale: 0.95 }}
                                href="https://wa.me/94770163670?text=Hello%20I%20would%20like%20to%20book%20the%20Kitulgala%20Water%20Rafting"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center justify-center px-14 py-4
                bg-green-500 text-white font-semibold text-lg
                rounded-full shadow-xl hover:bg-green-400
                transition-all duration-300"
                            >
                                Book Kitulgala Water Rafting
                            </motion.a>

                            <p className="mt-4 text-sm text-gray-200">
                                🌊 Adventure filled • 🕒 Flexible timing • 🦺 Safety equipment included
                            </p>
                        </motion.div>

                    </div>
                </section>


            </section>


        </div>
    );
}
